import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import MobileHeader from './MobileHeader/MobileHeader';
import TabletHeader from './TabletHeader/TabletHeader';

import { reducer, state } from '../../redux/sagas/aws-cognito-redux-saga';

import { getCurrentDiagnosisUser } from '../../redux/selectors/hairDiagnosis';
import { resetCurrentDiagnosisUser } from '../../redux/actions/hairDiagnosis';
import { fetchUser, clearCurrentUser } from '../../redux/actions/user';

const Header = styled.header`
  position: fixed;
  width: 100%;
  z-index: 98;
`;

class StylistHeader extends Component {
  componentDidMount() {
    const { stylist, auth, fetchUser, location } = this.props;
    this.getUserData({ stylist, auth, fetchUser, location });
  }

  componentWillReceiveProps(nextProps) {
    const { history, currentDiagnosisUser, locale, stylist, auth, fetchUser, location } = nextProps;
    if (this.props.currentDiagnosisUser && !currentDiagnosisUser) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    }

    if (auth.isSignedIn === state.AUTH_SUCCESS) {
      this.getUserData({ stylist, auth, fetchUser, location });
    }
  }

  getUserData = props => {
    const { auth, stylist, fetchUser, location } = props;

    if (
      auth &&
      auth.info &&
      auth.info.username &&
      !stylist.family_name &&
      ['login', 'forgot-password', 'change-password', 'sign-up'].every(el => !location.pathname.includes(el))
    ) {
      fetchUser(auth.info.username);
    }
  };

  handleLogout = () => {
    const { signOut, clearCurrentUser, resetCurrentDiagnosisUser } = this.props;
    signOut();
    clearCurrentUser();
    resetCurrentDiagnosisUser();
  };

  handleResetCurrentUser = () => {
    const { resetCurrentDiagnosisUser } = this.props;

    resetCurrentDiagnosisUser();
  };

  render() {
    const { location, copy, stylist } = this.props;
    return (
      <Header>
        <MobileHeader
          location={location}
          copy={copy}
          stylist={stylist}
          onLogout={this.handleLogout}
          onResetCurrentUser={this.handleResetCurrentUser}
        />
        <TabletHeader
          location={location}
          copy={copy}
          stylist={stylist}
          onLogout={this.handleLogout}
          onResetCurrentUser={this.handleResetCurrentUser}
        />
      </Header>
    );
  }
}

StylistHeader.defaultProps = {
  copy: {},
  currentDiagnosisUser: null,
};

StylistHeader.propTypes = {
  location: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
  stylist: PropTypes.shape({}).isRequired,
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  signOut: PropTypes.func.isRequired,
  currentDiagnosisUser: PropTypes.shape({}),
  resetCurrentDiagnosisUser: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  auth: PropTypes.shape({}).isRequired,
  clearCurrentUser: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolHeader,
  locale: state.locale,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  stylist: state.user,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  signOut: () => dispatch(reducer.signOut()),
  resetCurrentDiagnosisUser: () => dispatch(resetCurrentDiagnosisUser()),
  fetchUser: username => dispatch(fetchUser(username)),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
});

export default connect(mapState, mapDispatch)(StylistHeader);



// WEBPACK FOOTER //
// ./src/components/StylistHeader/StylistHeader.js